import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleSwitch',
  props: {
    isEnabled: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["onToggled"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

/**
 * トグル操作時のハンドラ。disabled時は何もしない。
 */
const onClick = () => {
  if (props.disabled) return;
  emits('onToggled', !props.isEnabled);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toggle-switch", { 'toggle-switch--disabled': _ctx.disabled }])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["toggle-switch__label", { 'toggle-switch__label--enabled': _ctx.isEnabled && !_ctx.disabled }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _createElementVNode("div", {
      class: "toggle-switch__switch",
      onClick: onClick
    }, [
      _createElementVNode("input", {
        type: "checkbox",
        class: "toggle-switch__switch__checkbox",
        disabled: _ctx.disabled
      }, null, 8, _hoisted_1),
      _createElementVNode("div", {
        class: _normalizeClass(["toggle-switch__switch__slider", { 'toggle-switch__switch__slider--enabled': _ctx.isEnabled, 'toggle-switch__switch__slider--disabled': !_ctx.isEnabled }])
      }, null, 2)
    ])
  ], 2))
}
}

})